<h1 mat-dialog-title>{{ data.title | translate }}</h1>

<div mat-dialog-content>
  <p>{{ data.content | translate }}</p>
</div>

<div mat-dialog-actions align="end">
  @if (!data.config?.disableClose) {
    <button matButton="outlined" mat-dialog-close color="primary">
      {{ 'COMMON.CANCEL' | translate }}
    </button>
  }

  <button matButton="filled" mat-dialog-close color="accent" (click)="data.onConfirm()" cdkFocusInitial>
    {{ data.confirmText || 'COMMON.CONFIRM' | translate }}
  </button>
</div>
